import Store from '@/store'

export default {
  data: function () {
    return {
      isShowModal: false,
    }
  },
  created: function () {
    const isCookieExist = this.$cookie.get(this._cookie.name)
    if (isCookieExist) {
      this.isShowModal = true
    }
  },
  computed: {
    _cookie: function () {
      return Store.state.constants.cookie.unconnectedOpenId
    }
  },
  methods: {
    modalOk: function () {
      this.modalClose()
      this.$router.push({ name: 'Profile', hash: '#connect-open-id' })
    },
    modalCrissCross: function () {
      this.modalClose()
    },
    modalClose: function () {
      this.isShowModal = false
      this.$cookie.delete(this._cookie.name, {
        domain: this._cookie.domain
      })
    }
  }
}


// WEBPACK FOOTER //
// ./src/components/tickets-and-bar/offer-use-open-id/script.js